import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { get, values, isEmpty } from 'lodash'
import { change, getFormValues, isDirty } from 'redux-form'

import StaffDetails from '../../components/SuitesStaff/Details'

import { MENU_TYPES } from '../../utils/menuTypes'

import {
  createAttendantSetting,
  loadAttendantSettings,
  removeAttendantSetting,
  updateAttendantSetting
} from '../../store/AppDeviceConfiguration/actions'
import { loadRevenueCenters } from '../../store/RevenueCenter/actions'
import { createSuitesStaff, loadSuitesStaff, removeSuitesStaff, updateSuitesStaff } from '../../store/Staff/actions'
import { createEmployeeRole, updateEmployeeRole } from '../../store/EmployeeRole/actions'
import { fetchEmployeeRoles } from '../../store/EmployeeRole/actions'
import { makeGetAttendantSetting } from '../../store/AppDeviceConfiguration/selector'
import { getFormRegisteredFields, makeGetAttendant } from '../../store/Staff/selector'
import { getCurrentVenueUuid } from '../../store/Venues/selector'
import { makeGetEmployeeRole } from '../../store/EmployeeRole/selector'

const mapStateToProps = ( state, ownProps ) => {
  const staffId = get(ownProps, 'match.params.staffId')

  const getAttendant = makeGetAttendant()
  const getAttendantSetting = makeGetAttendantSetting()
  const getEmployeeRole = makeGetEmployeeRole()

  const allMenuSubTypes = values(MENU_TYPES)
  const attendant = getAttendant(state, staffId)
  const attendantSetting = getAttendantSetting(state, get(attendant, 'uuid'))
  const menuSubtypes = get(attendantSetting, 'configuration.menuSubtypes') || []
  const attendantMenuSubtypes = menuSubtypes.map(type => MENU_TYPES[type]) // display values
  const attendantStandUuids = get(attendantSetting, 'configuration.standUuids') || []
  const legacyEmployeeRole = getEmployeeRole(state, attendant?.employeeId)
  const employeeRole = isEmpty(legacyEmployeeRole) ? getEmployeeRole(state, attendant?.id) : legacyEmployeeRole

  let initialRole = !isEmpty(employeeRole) ? { value: employeeRole?.role, deleteId: employeeRole?.uuid } : {}

  const currentVenueUuid = getCurrentVenueUuid(state)
  const initialValues = attendant

  const [firstName, ...lastName] = initialValues?.name?.split(' ') ?? ''

  initialValues['firstName'] = firstName
  initialValues['lastName'] = lastName.join(' ')
  initialValues['subTypes'] = attendantMenuSubtypes
  initialValues['standUuids'] = attendantStandUuids
  initialValues['deactivated'] = !!attendant.deactivatedAt

  const formFields = getFormRegisteredFields(state)
  const formValues = getFormValues('attendant-settings')(state)
  const formAltered = (field) => isDirty('attendant-settings')(state, [field])
  const formSubTypes = get(formValues, 'subTypes') || []
  const formStandUuids = get(formValues, 'standUuids') || []

  return {
    allMenuSubTypes,
    attendant,
    attendantMenuSubtypes,
    attendantSetting,
    attendantStandUuids,
    currentVenueUuid,
    employeeRole,
    formAltered,
    formFields,
    formStandUuids,
    formSubTypes,
    formValues,
    initialRole,
    initialValues,
    staffId
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const goBack = get(ownProps, 'history.goBack', () => {})
  return {
    createAttendantSetting: (currentVenueUuid, params) => dispatch(createAttendantSetting(currentVenueUuid, params)),
    loadAttendantSettings: (currentVenueUuid) => dispatch(loadAttendantSettings(currentVenueUuid)),
    onFieldValueChange: (field, value) => dispatch(change('attendant-settings', field, value)),
    onCreate: (currentVenueUuid, attendantParams, employeeRole) => dispatch(createSuitesStaff(currentVenueUuid, attendantParams, employeeRole)),
    onMount: (currentVenueUuid, employeeId) => {
      dispatch(loadRevenueCenters(currentVenueUuid))
      dispatch(loadSuitesStaff(currentVenueUuid))
      dispatch(fetchEmployeeRoles(currentVenueUuid, employeeId, null))
    },
    removeAttendant: (attendantUuid, attendantSettingUuid) => {
      dispatch(removeSuitesStaff(attendantUuid))
      dispatch(removeAttendantSetting(attendantSettingUuid))
    },
    updateAttendantSetting: (params) => dispatch(updateAttendantSetting(params)),
    updateSuitesStaff: (params) => dispatch(updateSuitesStaff(params)),
    onCreateEmployeeRole: (params) => dispatch(createEmployeeRole(params)),
    onUpdateEmployeeRole: (params, deleteId) => dispatch(updateEmployeeRole(params, deleteId)),
    onClose: () => {
      goBack()
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StaffDetails))
